/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { TimVisualReferenceVisualReferenceRect } from './TimVisualReferenceVisualReferenceRect';
import {
    TimVisualReferenceVisualReferenceRectFromJSON,
    TimVisualReferenceVisualReferenceRectFromJSONTyped,
    TimVisualReferenceVisualReferenceRectToJSON,
} from './TimVisualReferenceVisualReferenceRect';

/**
 * 
 * @export
 * @interface TimVisualReferenceVisualReference
 */
export interface TimVisualReferenceVisualReference {
    /**
     * 
     * @type {TimVisualReferenceVisualReferenceRect}
     * @memberof TimVisualReferenceVisualReference
     */
    rect: TimVisualReferenceVisualReferenceRect;
    /**
     * 
     * @type {string}
     * @memberof TimVisualReferenceVisualReference
     */
    text: string;
    /**
     * 
     * @type {string}
     * @memberof TimVisualReferenceVisualReference
     */
    page_num: string;
    /**
     * 
     * @type {string}
     * @memberof TimVisualReferenceVisualReference
     */
    document_id: string;
    /**
     * 
     * @type {string}
     * @memberof TimVisualReferenceVisualReference
     */
    document_name: string;
}

/**
 * Check if a given object implements the TimVisualReferenceVisualReference interface.
 */
export function instanceOfTimVisualReferenceVisualReference(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "rect" in value;
    isInstance = isInstance && "text" in value;
    isInstance = isInstance && "page_num" in value;
    isInstance = isInstance && "document_id" in value;
    isInstance = isInstance && "document_name" in value;

    return isInstance;
}

export function TimVisualReferenceVisualReferenceFromJSON(json: any): TimVisualReferenceVisualReference {
    return TimVisualReferenceVisualReferenceFromJSONTyped(json, false);
}

export function TimVisualReferenceVisualReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimVisualReferenceVisualReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'rect': TimVisualReferenceVisualReferenceRectFromJSON(json['rect']),
        'text': json['text'],
        'page_num': json['page_num'],
        'document_id': json['document_id'],
        'document_name': json['document_name'],
    };
}

export function TimVisualReferenceVisualReferenceToJSON(value?: TimVisualReferenceVisualReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'rect': TimVisualReferenceVisualReferenceRectToJSON(value.rect),
        'text': value.text,
        'page_num': value.page_num,
        'document_id': value.document_id,
        'document_name': value.document_name,
    };
}

